export default __webpack_public_path__ + "static/media/fake-club.66a6bc49.svg";